import { alpha, Link, LinkProps, styled } from '@mui/material';
import {
  Link as ReactRouterLink,
  LinkProps as ReactRouterLinkProps,
} from 'react-router-dom';

import { removeTheseProps } from '@/utils';

export type RouterLinkProps = LinkProps<'a', ReactRouterLinkProps> & {
  linkColor?: string;
  linkColorAlpha?: number;
};

export const RouterLink = styled(
  (props: RouterLinkProps) => {
    return <Link component={ReactRouterLink} {...props} />;
  },
  {
    shouldForwardProp: removeTheseProps<RouterLinkProps>(
      'linkColor',
      'linkColorAlpha',
    ),
  },
)<RouterLinkProps>(({ linkColor, linkColorAlpha }) => {
  const color = linkColor || '#0075C9';

  return {
    color,
    '&:hover': {
      color: alpha(color, linkColorAlpha ?? 0.8),
    },
    '&.MuiLink-underlineAlways': {
      textDecoration: 'underline',
    },
  };
});
